export default __webpack_public_path__ + "static/media/presidente.b3e9d1c4.png";